import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { GeneralAssumptions } from '../../../../components/GeneralAssumptions/GeneralAssumptions';
import { useAssumptions } from './useAssumptions';

export const ASSUMPTIONS_TITLE = 'Below are the assumptions made for this plan';

export const Assumptions: React.FC = () => {
  const { data } = useAssumptions();

  if (!data) {
    return null;
  }

  const isDaf = data.GivingStrategy === 'DonationsToADaf';

  const { startYearLabel, endYearLabel } = isDaf
    ? { startYearLabel: 'Donation Year', endYearLabel: 'Grant Year' }
    : { startYearLabel: 'Donation Start Year', endYearLabel: 'Donation End Year' };

  return (
    <Box>
      <Text variant="cardTitle" p="16">
        {ASSUMPTIONS_TITLE}
      </Text>
      <HtmlTable>
        <table>
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>

          <caption>Charitable Giving Assumptions</caption>

          <thead>
            <tr>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Assumption
                </Text>
              </th>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Value
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            {data.PropertyType && (
              <tr>
                <Text as="td" fontWeight={500}>
                  Property Type
                </Text>

                <Box as="td">
                  <Text fontWeight={500}>{data.PropertyType}</Text>
                </Box>
              </tr>
            )}

            <tr>
              <Text as="td" fontWeight={500}>
                Donation Amount
              </Text>

              <Text as="td" fontWeight={500}>
                {typeof data.DonationAmount === 'number'
                  ? formatCurrency(data.DonationAmount)
                  : data.DonationAmount}
              </Text>
            </tr>

            <tr>
              <Text as="td" fontWeight={500}>
                {startYearLabel}
              </Text>

              <Box as="td">
                <Text fontWeight={500}>{data.DonationYear || data.DonationStartYear}</Text>
              </Box>
            </tr>

            {(data.GrantYear || data.DonationEndYear) && (
              <tr>
                <Text as="td" fontWeight={500}>
                  {endYearLabel}
                </Text>

                <Text as="td" fontWeight={500}>
                  {data.GrantYear || data.DonationEndYear}
                </Text>
              </tr>
            )}

            {data.GrantAmount && (
              <tr>
                <Text as="td" fontWeight={500}>
                  Grant Amount
                </Text>

                <Text as="td" fontWeight={500}>
                  {data.GrantAmount}
                </Text>
              </tr>
            )}

            <tr>
              <Text as="td" fontWeight={500}>
                Earmarked Accounts
              </Text>

              <Text as="td" fontWeight={500}>
                {data.EarmarkedAccounts}
              </Text>
            </tr>
          </tbody>
        </table>
      </HtmlTable>

      <GeneralAssumptions mt="24" />
    </Box>
  );
};
